import { render, staticRenderFns } from "./Organizer.vue?vue&type=template&id=6ee4471b"
import script from "./Organizer.vue?vue&type=script&lang=ts"
export * from "./Organizer.vue?vue&type=script&lang=ts"
import style0 from "./Organizer.vue?vue&type=style&index=0&id=6ee4471b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports